import { DOCUMENT_CHECK_ID, IOcrConf, IOcrCannyConf, IOcr, IOcrManualConf } from '../../models/ocr';
import { TestStatus } from '../../models/user-identification';

/** Umbrales de nitidez OCR (Laplacian RMS y Fourier HF). Fuente única para ocr-conf y /models/document. Mobile / default. */
export const OCR_SHARPNESS_DEFAULTS = {
	// NIF-985: endurecer móvil (análisis nitidez + feedback Gemma); PC sin cambio (NIF-730).
	minSharpnessLapacian: 14,
	minSharpnessFourier: 60,
} as const;

/** Umbrales desktop (NIF-730): más bajos que mobile para no bloquear captura en webcam de PC. */
export const OCR_SHARPNESS_DESKTOP = {
	minSharpnessLapacian: 6,
	minSharpnessFourier: 50,
} as const;

export const ocrConf: IOcrConf = {
	document: [],
	general: {
		startAt: '',
		finishAt: '',
		minPercenteageTimeInMiddle: 75,
		timeBetweenTest: 1,
		controlValidation: false,
		messages: {
			onInit: '',
			onWarning: 'LIFE_CHECK.GENERAL.TEXT.ONWARNING',
			onFail: 'LIFE_CHECK.GENERAL.TEXT.ONFAIL',
			onComplete: '',
		},
		tries: 1,
		countTries: 0,
		complete: false,
		status: TestStatus.OnInit,
		...OCR_SHARPNESS_DEFAULTS,
		maxConsecutiveCellsWith95: 4,
		maxConsecutiveCellsWith98: 2,
	},
};

export const ocrBackConf: IOcr = {
	documentTestId: DOCUMENT_CHECK_ID.BACK,
	minPercentageDocument: 70,
	photos: [],
	status: TestStatus.OnInit,
	complete: false,
	startAt: '',
	finishAt: '',
	maxTime: 150,
	minTime: 2,
	countTries: 1,
	tries: 2,
	showAnimation: true,
	messages: {
		onInit: `OCR.BACK.INSTRUCTIONS.TEXT.ONINIT`,
		onWarning: 'OCR.BACK.INSTRUCTIONS.TEXT.ONWARNING',
		onFail: 'LIFE_CHECK.GENERAL.TEXT.ONWARNING',
		onComplete: '',
	},
};

export const ocrFrontConf: IOcr = {
	documentTestId: DOCUMENT_CHECK_ID.FRONT,
	minPercentageDocument: 70,
	photos: [],
	status: TestStatus.OnInit,
	complete: false,
	startAt: '',
	finishAt: '',
	countTries: 1,
	tries: 2,
	maxTime: 150,
	minTime: 2,
	showAnimation: true,
	messages: {
		onInit: 'OCR.FRONT.INSTRUCTIONS.TEXT.ONINIT',
		onWarning: 'OCR.FRONT.INSTRUCTIONS.TEXT.ONWARNING',
		onFail: 'LIFE_CHECK.GENERAL.TEXT.ONWARNING',
		onComplete: '',
	},
};

export const manualOcrConf: IOcrManualConf = {
	document: [],
	general: {
		startAt: '',
		finishAt: '',
		maxTime: 300,
		status: TestStatus.OnInit,
		observations: [],
	},
};

// Deprecated
export const ocrBackConfWithOutModels: IOcrCannyConf = {
	document: {
		documentTestId: DOCUMENT_CHECK_ID.BACK,
		minSharpness: 6,
		photos: [],
		status: TestStatus.OnInit,
		complete: false,
		maxTime: 60,
		messages: {
			onInit: `Mantenga la parte trasera del documento dentro del recuadro`,
			onWarning: 'Mantenga la parte trasera del documento dentro del recuadro',
			onFail: 'Lo sentimos, no somos capaces de identificar el documento',
			onComplete: '',
		},
		countTries: 1,
		tries: 3,
		startAt: '',
		finishAt: '',
	},
	general: {
		startAt: '',
		finishAt: '',
		messages: {
			onInit: ``,
			onWarning: 'Para ayudarte volvamos a empezar',
			onFail: 'Lo sentimos, no somos capaces de realizar el proceso. Inténtelo de manera manual',
			onComplete: 'Proceso realizado correctamente',
		},
		tries: 1,
		countTries: 0,
		controlValidation: false,
		complete: false,
		status: TestStatus.OnInit,
	},
};

export const ocrFrontConfWithOutModels: IOcrCannyConf = {
	document: {
		documentTestId: DOCUMENT_CHECK_ID.FRONT,
		minSharpness: 6,
		photos: [],
		status: TestStatus.OnInit,
		complete: false,
		maxTime: 60,
		messages: {
			onInit: `Mantenga la parte delantera del documento dentro del recuadro`,
			onWarning: 'Mantenga la parte delantera del documento dentro del recuadro',
			onFail: 'Lo sentimos, no somos capaces de identificar el documento',
			onComplete: '',
		},
		countTries: 1,
		tries: 3,
		startAt: '',
		finishAt: '',
	},
	general: {
		startAt: '',
		finishAt: '',
		messages: {
			onInit: ``,
			onWarning: 'Para ayudarte volvamos a empezar',
			onFail: 'Lo sentimos, no somos capaces de realizar el proceso. Inténtelo de manera manual',
			onComplete: 'Proceso realizado correctamente',
		},
		tries: 1,
		countTries: 0,
		controlValidation: false,
		complete: false,
		status: TestStatus.OnInit,
	},
};
